import { render, staticRenderFns } from "./Thumbs.vue?vue&type=template&id=4e19cf4f&scoped=true&"
import script from "./Thumbs.vue?vue&type=script&lang=js&"
export * from "./Thumbs.vue?vue&type=script&lang=js&"
import style0 from "./Thumbs.vue?vue&type=style&index=0&id=4e19cf4f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e19cf4f",
  null
  
)

export default component.exports